// console.log(`js/01-pageSections/programCards.js is working`);

const programCards = document.querySelectorAll(`.program`);

for(let i = 0; i < programCards.length; i++) {

  programCards[ i ].addEventListener(`click`, checkProgramCard);
  programCards[ i ].setAttribute(`data-number`, i + 1);
}

function checkProgramCard() {
  let activeProgramCard = this;
  let readMore = this.querySelector(`.programread-more`);
  let checkWhereClick = readMore.contains(event.target);

  if(!readMore.classList.contains(`programcard-active`)) {
    enlargeProgramCard(activeProgramCard);
  } else if(readMore.classList.contains(`programcard-active`) && checkWhereClick) {
    returnProgramCard(activeProgramCard);
  }

  document.addEventListener(`click`, function () {
    checkProgramClick(activeProgramCard);
  });
}

function checkProgramClick(card) {
  let isClickInsideProgram = card.contains(event.target);
  if(!isClickInsideProgram) {
    returnProgramCard(card);
  }
}

function enlargeProgramCard(card) {
  let cardNumber = card.getAttribute(`data-number`);
  let readMore = card.querySelector(`.programread-more`);

  readMore.innerHTML = `Show Less`;
  card.classList.add(`program-active`);
  card.classList.remove(`return-program`);
  readMore.classList.add(`programcard-active`);

  if(cardNumber % 3 === 2) {
    card.classList.add(`middle-programcard-active`);
  } else if(cardNumber % 3 === 1) {
    card.classList.add(`left-programcard-active`);
  } else if(cardNumber % 3 === 0) {
    card.classList.add(`right-programcard-active`);
  }
  card.setAttribute(`id`, `returned`);
}

function returnProgramCard(card) {
  let readMore = card.querySelector(`.programread-more`);
  let cardNumber = card.getAttribute(`data-number`);
  let details = card.querySelector(`.program-details`);

  details.scrollTop = 0;
  card.classList.remove(`program-active`);
  readMore.classList.remove(`programcard-active`);
  card.scrollIntoView({ behavior: `smooth` });
  if(cardNumber % 3 === 2) {
    card.classList.remove(`middle-programcard-active`);
  } else if(cardNumber % 3 === 1) {
    card.classList.remove(`left-programcard-active`);
  } else if(cardNumber % 3 === 0) {
    card.classList.remove(`right-programcard-active`);
  }

  card.classList.add(`return-program`);
  card.parentNode.style.removeProperty(`justify-self`);
  readMore.innerHTML = `Read More`;
  card.removeAttribute(`id`, `program-active`);
}